import { Component, Input, NgZone } from '@angular/core';
import { GigyaService } from 'src/app/services/gigya/gigya.service';
import { paramsShowScreenSet } from 'src/app/types/gigya-type';

@Component({
  selector: 'app-tutor-profile',
  templateUrl: './tutor-profile.component.html',
  styleUrls: ['./tutor-profile.component.scss']
})
export class TutorProfileComponent {
  @Input() lang: string="";

constructor(
  private gigya: GigyaService,
  private ngZone: NgZone,
){

}

ngAfterViewInit(){
  this.ngZone.run(() => {
    let params: paramsShowScreenSet = {
      screenSet: "Parent-ProfileUpdate",
      startScreen: "gigya-update-profile-screen",
      containerID: "tutorProfileContainer",
      lang: this.lang
    }
    this.gigya.showScreenSet(params);
  });
}
}
